import React, { Fragment, memo, useCallback, useEffect, useLayoutEffect, useMemo, useState } from "react";
import AvatarName from "../../UniversalComponents/AvatarName";
import { useVirtualizer } from "@tanstack/react-virtual";
import { useRef } from "react";

import { ReactComponent as SearchIcon } from "../../../assets/images/icons/searchIconDark.svg";
import { ReactComponent as CloseModalImg } from "../../../assets/images/Vector.svg";
import { ReactComponent as Cross } from "../../../assets/images/icons/Cross.svg";
import { ReactComponent as Inprogress } from "../../../assets/images/icons/InProgress.svg";
import { ReactComponent as Completed } from "../../../assets/images/icons/Completed.svg";
import { ReactComponent as Hold } from "../../../assets/images/icons/Hold.svg";
import { ReactComponent as WhiteCross } from "../../../assets/images/icons/WhiteCross.svg";
import { ReactComponent as Inprogres } from "../../../assets/images/icons/InProgres.svg";
import { ReactComponent as CompletedEmpty } from "../../../assets/images/icons/CompletedEmpty.svg";
import { ReactComponent as HoldEmpty } from "../../../assets/images/icons/HoldEmpty.svg";
import { ReactComponent as CancelEmtpy } from "../../../assets/images/icons/CancelEmpty.svg";
import { ReactComponent as Default } from "../../../assets/images/icons/defaultIcon.svg";
import { ReactComponent as DropIcon } from "../../../assets/images/icons/DropIcon.svg";
import { ReactComponent as DropEmpty } from "../../../assets/images/NoUserManagement.svg";
import { ReactComponent as NotStartedEmpty } from "../../../assets/images/icons/NotStartedEmpty.svg";
import { useDispatch } from "react-redux";

import { NODE_URL } from "../../../utils/constants";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";
import { pushAlert } from "../../../utils/alertSlice";
import { useParams } from "react-router-dom";
import { transform } from "framer-motion";
import { ReactComponent as WhiteSearch } from "../../../assets/images/icons/WhiteSearch.svg";
import { usePostApiMutation, useUpdateTaskCompletionMutation } from "../../../utils/customer/customerTaskTable";
import VirtualRow from "./KanBanVirtualRow";
import _ from "lodash";
import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import UniversalCardComponent from "../../UniversalComponents/UniversalCardComponent";

const arePropsEqual = (prevProps, nextProps) => {
  return _.isEqual(prevProps.getkanaBanData, nextProps.getkanaBanData);
};

const LabelColor = (value) => {
  const v = value?.toLowerCase();

  switch (v) {
    case "not started":
      return "#0E8BFE";

    case "work in progress":
    case "in progress":
      return "#F16136";

    case "completed":
      return "#008937";

    case "hold":
      return "#EE950F";

    case "drop":
      return "#9A0D94";

    case "cancelled":
      return "#BC1203";

    default:
      return "gray";
  }
};
const KanbanColumn = ({
  items,
  searchValue,
  onClick,

  completedTasks,
  setCompletedTasks,
  fetchKanbanData,
  recentlyDroppedItemId,
  Itemlength,
  categoryColours,
  scrollToFn,
  EmptyKanBanData,
  category_filter,
  setSeriesRecurModel,
  isDraggingOver,
  hoverIndex,
  setHoverIndex,
}) => {
  console.log("items");

  const parentRef = useRef(null);

  const [columnItems, setColumnItems] = useState(items?.boardData || []);

  useEffect(() => {
    setColumnItems(items?.boardData || []);
  }, [items?.boardData]);

  const isItemMatched = (item, searchValue) => {
    if (!searchValue?.trim()) return true;
    if (!item) return false;

    const words = searchValue.trim().toLowerCase().split(/\s+/);

    return words.some((word) => {
      const match =
        item?.subject?.toLowerCase()?.includes(word) ||
        item?.category_id?.toLowerCase()?.includes(word) ||
        item?.priority?.toLowerCase()?.includes(word) ||
        item?.start_date?.toLowerCase()?.includes(word) ||
        item?.end_date?.toLowerCase()?.includes(word) ||
        item?.updated_by?.toLowerCase()?.includes(word) ||
        item?.sub_tasks?.some((t) => t?.subject?.toLowerCase()?.includes(word)) ||
        item?.tag?.some((t) => t?.tag_name?.toLowerCase()?.includes(word)) ||
        item?.assigned_to?.some((a) => a?.name?.toLowerCase()?.includes(word));

      return Boolean(match); // ✅ explicit: if no field matches → false
    });
  };

  const filteredItems = columnItems?.filter((item) => {
    // filter and highLight all the data
    if (!searchValue) return true;
    const query = searchValue?.toLowerCase();
    return isItemMatched(item, query);
  });

  const virtualizer = useVirtualizer({
    count: filteredItems.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 150,
    overscan: 5,
    scrollToFn,
  });

  return (
    <div
      ref={parentRef}
      className="min-h-0 w-full h-full grow  overflow-y-scroll  thinscrollbar"
      style={{
        msOverflowStyle: "none",
        height: "100%",
        borderLeft: "1px solid #d2dae140",
        borderRight: "1px solid #d2dae140",
        // overflowY: "auto",
        // scrollbarWidth: "none",
      }}
      onMouseMove={(e) => {
        if (!isDraggingOver) return;

        const rect = parentRef.current.getBoundingClientRect();
        const offsetY = e.clientY - rect.top + parentRef.current.scrollTop;

        const index = virtualizer
          .getVirtualItems()
          .find((v) => offsetY >= v.start && offsetY <= v.start + v.size)?.index;

        if (index !== undefined) {
          setHoverIndex(index);
        }
      }}
    >
      <div
        style={{
          height:
            Itemlength === 0
              ? "100%"
              : `${virtualizer.getVirtualItems().reduce((total, item) => total + item.size, 0)}px`,
          position: "relative",
          width: "100%",
        }}
      >
        {items?.boardData?.length === 0 ? (
          <div className="flex items-center justify-center h-full min-h-[150px]">
            <EmptyKanBanData label={items?.label} category={category_filter} />
          </div>
        ) : (
          searchValue &&
          filteredItems.length === 0 && (
            <div className="flex items-center justify-center h-full min-h-[calc(100vh-280px)]">
              <span className="text-gray-400 text-center">{searchValue} is not found.</span>
            </div>
          )
        )}

        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            transform: `translateY(${virtualizer.getVirtualItems()[0]?.start ?? 0}px`,
            paddingRight: "4px",
            paddingLeft: "15px",
            paddingTop: "2px",
          }}
        >
          {virtualizer.getVirtualItems().map((virtualRow, key) => {
            const item = filteredItems[virtualRow.index];
            const showDropBox = isDraggingOver && hoverIndex === virtualRow.index;

            return (
              <div
                className="w-full bg-[#F7F8FA] rounded-lg"
                style={{ paddingBottom: "3px", paddingTop: "3px" }}
                key={key}
                ref={virtualizer.measureElement}
                data-index={virtualRow}
              >
                {showDropBox && (
                  <div
                    style={{ borderColor: LabelColor(items?.label), opacity: 0.8 }}
                    className={`border-t-2 border-dashed mt-1 px-2 w-full`}
                  />
                )}
                <VirtualRow
                  item={item}
                  index={virtualRow.index}
                  virtualRow={virtualRow}
                  onClick={onClick}
                  searchValue={searchValue}
                  recentlyDroppedItemId={recentlyDroppedItemId}
                  fetchKanbanData={fetchKanbanData}
                  measureElement={virtualizer.measureElement}
                  dataIndex={virtualRow.index}
                  virtualizer={virtualizer}
                  categoryColours={categoryColours}
                  setSeriesRecurModel={setSeriesRecurModel}
                  completedTasks={completedTasks}
                  setCompletedTasks={setCompletedTasks}
                />
              </div>
            );
          })}
        </div>
      </div>
      <style>
        {`
    .thinscrollbar::-webkit-scrollbar {
      width: 6px;
      background-color: transparent;
    }

    .thinscrollbar::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: transparent;
    }

    .thinscrollbar:hover::-webkit-scrollbar-thumb {
      background-color: grey;
    }

    .thinscrollbar {
      scrollbar-width: thin;
      scrollbar-color: transparent transparent;
    }

    .thinscrollbar:hover {
      scrollbar-color: grey transparent;
    }
  `}
      </style>
    </div>
  );
};

const KanBanBoard = ({
  category_filter = {},
  // isPopupOpen,
  // setIsPopupOpen,
  // editData,
  setEditData,
  // setActivityState,
  fetchKanbanData,
  iskanaBanDataSuccess,
  getkanaBanData,
  iskanaBanDataLoading,
  iskanaBanDataError,
  kanaBanDataError,
  setSeriesRecurModel,
  columnSearchTerms,
  setColumnSearchTerms,
}) => {
  const { id: customerId } = useParams();
  const [kanBanData, setKanBanData] = useState([]);
  const [recentlyDroppedItemId, setRecentlyDroppedItemId] = useState(null);
  const [completedTasks, setCompletedTasks] = useState([]);
  const [checkedTasks, setCheckedTasks] = useState({});
  const [searchLabel, setSearchLabel] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);

  const dispatch = useDispatch();
  const parentRef = useRef < HTMLDivElement > null;

  const handleDrop = ({ draggedItem, sourceLabel, destinationLabel }) => {
    if (!draggedItem || sourceLabel === destinationLabel) return;

    // 1️⃣ Optimistic UI update
    setKanBanData((prev) => {
      const updated = prev.newTransformed.map((col) => {
        if (col.label === destinationLabel) {
          return {
            ...col,
            boardData: [draggedItem, ...col.boardData],
          };
        }

        if (col.label === sourceLabel) {
          return {
            ...col,
            boardData: col.boardData.filter((i) => i.id !== draggedItem.id),
          };
        }

        return col;
      });

      return { ...prev, newTransformed: updated };
    });

    // 2️⃣ Highlight dropped item
    setRecentlyDroppedItemId(draggedItem.id);
    setTimeout(() => setRecentlyDroppedItemId(null), 2000);

    // 3️⃣ API call
    UpdateKanBanData({
      data: {
        task_id: draggedItem.id,
        status: destinationLabel,
      },
      url: `${NODE_URL}task/kanban/update-status`,
    });
  };

  const handleDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (source.droppableId === destination.droppableId) return;

    const sourceColumn = kanBanData.newTransformed.find((col) => col.label === source.droppableId);

    const draggedItem = sourceColumn.boardData[source.index];

    handleDrop({
      draggedItem,
      sourceLabel: source.droppableId,
      destinationLabel: destination.droppableId,
    });
  };

  const [
    UpdateKanBanData,
    {
      isSuccess: isUpdatekanaBanDataSuccess,
      data: getUpdatekanaBanData,
      isLoading: isUpdatekanaBanDataLoading,
      isError: isUpdatekanaBanDataError,
      error: UpdatekanaBanDataError,
    },
  ] = usePostApiMutation();

  useEffect(() => {
    fetchKanbanData();
  }, [category_filter]);

  useEffect(() => {
    if (iskanaBanDataLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (iskanaBanDataSuccess) {
      // dispatch(
      //   pushAlert({
      //     message:
      //       getkanaBanData?.success || getkanaBanData?.data
      //         ? getkanaBanData.message || "Get data successfully"
      //         : "Something went wrong",
      //     type: getkanaBanData?.success || getkanaBanData?.data ? "success" : "danger",
      //     visible: true,
      //   })
      // );
      if (getkanaBanData?.data || getkanaBanData?.success) {
        const board = getkanaBanData?.data;
        const countsList = getkanaBanData?.counts || {};

        const transformed = Object?.entries(board)?.map(([label, boardData]) => ({
          label,
          boardData,
        }));

        const newTransformed = [];

        Object?.keys(countsList)?.forEach((eachCount) => {
          const flag = transformed?.find((item) => item.label === eachCount);
          if (flag) {
            newTransformed.push(flag);
          } else {
            newTransformed.push({ label: eachCount, boardData: [] });
          }
        });

        setKanBanData({ newTransformed, categoryColours: getkanaBanData?.color });
      }
    }

    if (iskanaBanDataError) {
      dispatch(
        pushAlert({
          message: kanaBanDataError?.data?.message || "Error occurred",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [iskanaBanDataLoading, iskanaBanDataSuccess, iskanaBanDataError, getkanaBanData?.data]);

  useEffect(() => {
    if (isUpdatekanaBanDataLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isUpdatekanaBanDataSuccess) {
      dispatch(
        pushAlert({
          message: getUpdatekanaBanData?.success
            ? getUpdatekanaBanData?.message || "updated successfully"
            : "Something went wrong",
          type: getUpdatekanaBanData?.success ? "success" : "danger",
          visible: true,
        })
      );

      if (getUpdatekanaBanData?.success) {
        fetchKanbanData();
        setCheckedTasks({});
      }
    }

    if (isUpdatekanaBanDataError) {
      dispatch(
        pushAlert({
          message: UpdatekanaBanDataError?.data?.message || "Error occurred",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isUpdatekanaBanDataSuccess, isUpdatekanaBanDataLoading, isUpdatekanaBanDataError]);

  const IsSearch = (label) => {
    if (label) {
      setSearchLabel(label);
    }
    if (label === searchLabel) {
      setSearchLabel(null);
    }
  };

  const EmptyKanBanData = ({ label, category }) => {
    switch (label.toLowerCase()) {
      case "not started":
        return (
          <div className="flex items-center flex-col justify-center gap-y-2">
            <NotStartedEmpty />
            <label className="text-gray-400  text-centre">
              {/* {label === "not started" ? "" : "No"} {category === "all"? "Data is" : category} {label} */}
            </label>
          </div>
        );
      case "work in progress" || "In Progress":
        return (
          <div className="flex items-center flex-col justify-center gap-y-2">
            <Inprogres />
            <label className="text-gray-400  text-centre">
              {/* No {category === "all"? "Data is" : category} {label} */}
            </label>
          </div>
        );

      case "completed":
        return (
          <div className="flex items-center flex-col justify-center gap-y-2">
            <CompletedEmpty />
            <label className="text-gray-400  text-centre">
              {/* No {category === "all"? "Data is" : category} {label} */}
            </label>
          </div>
        );

      case "hold":
        return (
          <div className="flex items-center flex-col justify-center gap-y-2">
            <HoldEmpty />
            <label className="text-gray-400  text-centre">
              {/* No {category === "all"? "Data is" : category} {label} */}
            </label>
          </div>
        );
      case "drop":
        return (
          <div className="flex items-center flex-col justify-center gap-y-2">
            <DropEmpty className="h-40 w-40" />
            <label className="text-gray-400  text-center">
              {/* No {category === "all"? "Data is" : category} {label} */}
            </label>
          </div>
        );

      case "cancelled":
        return (
          <div className="flex items-center flex-col justify-center gap-y-2">
            <CancelEmtpy />
            <label className="text-gray-400  text-centre">
              {/* No {category === "all"? "Data is" : category} {label} */}
            </label>
          </div>
        );
      default:
        return (
          <span className="flex items-center flex-col justify-center">
            {/* <label className="text-gray-400">No Data is Present</label> */}
          </span>
        );
    }
  };

  const isScrolling = useRef(false);

  const easeInOutQuint = (t) => (t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t);

  const scrollToFn = (offset, canSmooth, instance) => {
    if (isScrolling.current) return; // Prevent recursive scroll calls

    const duration = 300;
    const start = parentRef.current?.scrollTop || 0;
    const startTime = Date.now();
    let animationFrameId;

    isScrolling.current = true;

    const run = () => {
      const now = Date.now();
      const elapsed = now - startTime;
      const progress = easeInOutQuint(Math.min(elapsed / duration, 1));
      const interpolated = start + (offset - start) * progress;

      instance?.scrollToOffset(interpolated);

      if (elapsed < duration) {
        animationFrameId = requestAnimationFrame(run);
      } else {
        isScrolling.current = false;
      }
    };

    run();

    return () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      isScrolling.current = false;
    };
  };
  const hexToRgba = (hex, alpha) => {
    hex = hex.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const BackgroundColorMatch = (value) => {
    switch (value.toLowerCase()) {
      case "not started":
        return "#0E8BFE";
      case "work in progress" || "In Progress":
        return "#F16136";

      case "completed":
        return "#008937";

      case "hold":
        return "#EE950F";
      case "drop":
        return "#9A0D94";

      case "cancelled":
        return "#BC1203";
      default:
        return "bg-gray-500";
    }
  };

  function toPascalCase(str) {
    return str
      ?.toLowerCase()
      ?.split(" ")
      ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return (
    <>
      <DragDropContext onDragEnd={handleDragEnd}>
        <div className="w-full min-h-0 grow flex items-center overflow-x-scroll bg-white justify-start py-3  gap-4">
          {kanBanData?.newTransformed?.map((items, index) => {
            const searchValue = columnSearchTerms || "";
            // const filteredBoardData = items?.boardData?.filter((item) => isItemMatched(item, searchValue));
            return (
              <Droppable
                droppableId={items.label}
                mode="virtual"
                key={index}
                renderClone={(provided, snapshot, rubric) => {
                  const item = items.boardData[rubric.source.index];
                  if (!item) return null;

                  return (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className="bg-103149 rounded-lg"
                      style={{
                        ...provided.draggableProps.style,
                        transform: `${provided.draggableProps.style?.transform} rotate(-4deg)`,
                        boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
                        cursor: "grabbing",
                      }}
                    >
                      <UniversalCardComponent item={item} isDragOverlay />
                    </div>
                  );
                }}
              >
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="h-full min-w-[24vw] flex flex-col items-center justify-start bg-white thinscrollbar rounded-lg"
                  >
                    {/* Column Header */}
                    <div
                      className={`w-full flex items-center justify-between pt-4 pb-3 px-6 rounded-t-3xl`}
                      // style={{ backgroundColor: hexToRgba(BackgroundColorMatch(items?.label), 0.3) }}
                      style={{
                        borderLeft: "1px solid #d2dae140",
                        borderRight: "1px solid #d2dae140",
                        // borderTop: `4px solid ${hexToRgba(BackgroundColorMatch(items?.label), 1)}`,
                        backgroundColor: "#F7F8FA",
                      }}
                    >
                      <div className="flex items-center justify-start gap-x-1 ">
                        {/* {LabelColor(items?.label)} */}

                        <label
                          style={{ color: LabelColor(items?.label) }}
                          className="text-lg font-600 flex items-center gap-x-1"
                        >
                          {toPascalCase(items?.label)}
                          <span>({items?.boardData?.length})</span>
                        </label>
                      </div>
                      {/* <div
                    className="flex items-center justify-centre p-2 bg-[#FFFFFF66] rounded-md cursor-pointer"
                    onClick={() => IsSearch(items?.label)}
                  >
                    <WhiteSearch />
                  </div> */}
                    </div>

                    {/* Search Input */}

                    {/* {searchLabel === items?.label && (
                  <div
                    className="w-full pt-3"
                    style={{ backgroundColor: hexToRgba(BackgroundColorMatch(items?.label), 0.06) }}
                  >
                    <div className="flex items-center justify-center w-full">
                      <div className="relative flex left-7 items-center justify-end w-fit">
                        <SearchIcon />
                      </div>
                      <input
                        type="text"
                        placeholder="Search"
                        value={columnSearchTerms || ""}
                        onChange={(e) => handleItemSearch(e, items.label)}
                        className="h-[30px] w-full pl-10 pr-8 border-[1px]  border-gray-300 rounded-[5px] text-xs focus:outline-none focus:ring-0 focus:border-D9D9D9"
                      />
                      <div
                        className="relative right-7 flex items-center justify-end cursor-pointer"
                        onClick={() => handleSearchItemClear(items.label)}
                      >
                        <CloseModalImg />
                      </div>
                    </div>
                  </div>
                )} */}

                    <div
                      className="w-full h-full overflow-hidden "
                      style={{
                        // backgroundColor: hexToRgba(BackgroundColorMatch(items?.label), 0.06),
                        backgroundColor: "#F7F8FA",
                        scrollBehavior: "smooth",
                      }}
                    >
                      {/* column render */}
                      <KanbanColumn
                        key={index}
                        items={items}
                        searchValue={searchValue}
                        onClick={(data) => setEditData(data)}
                        fetchKanbanData={fetchKanbanData}
                        recentlyDroppedItemId={recentlyDroppedItemId}
                        Itemlength={items?.boardData?.length}
                        data-index={index}
                        categoryColours={kanBanData?.categoryColours}
                        completedTasks={completedTasks}
                        setCompletedTasks={setCompletedTasks}
                        scrollToFn={scrollToFn}
                        EmptyKanBanData={EmptyKanBanData}
                        category_filter={category_filter}
                        setSeriesRecurModel={setSeriesRecurModel}
                        isDraggingOver={snapshot.isDraggingOver}
                        hoverIndex={hoverIndex}
                        setHoverIndex={setHoverIndex}
                      />
                    </div>
                  </div>
                )}
              </Droppable>
            );
          })}
        </div>
      </DragDropContext>
    </>
  );
};

export default KanBanBoard;
